import { createStandardAction } from "typesafe-actions";

export const setWarning = createStandardAction("@@utils/SET_WARNING")();